if (!customElements.get('product-form')) {
  customElements.define(
    'product-form',
    class ProductForm extends HTMLElement {
      constructor() {
        super();

        this.form = this.querySelector('form');
        this.variantIdInput.disabled = false;
        this.submitButton = this.querySelectorAll('.add-to-cart__submit-button');
        this.submitButton.forEach((button) => {
          button.addEventListener('click', this.onSubmitHandler.bind(this));
        });

        this.additionalProducts = [];

        this.hideErrors = this.dataset.hideErrors === 'true';

        this.allocationPriceRender = this.querySelector('[allocation-price-render]');
        this.checkedAllocation = this.querySelector('.delivery-item [checked]');

        if (this.checkedAllocation && this.checkedAllocation) {
          this.allocationPriceRender.textContent = this.checkedAllocation.dataset.variantPrice;
        }

        this.oneTimeBannerWithEmoticon = this.querySelector('.one-time-banner-with-emoticon');

        if (this.oneTimeBannerWithEmoticon) {
          this.oneTimeBannerWithEmoticon.addEventListener('click', this.onClickOneTimeBanner.bind(this));
        }

        // document.querySelectorAll('.delivery-item input[type="radio"][data-radio-type="selling_plan"]').forEach((radio) => {
        //   console.log('radio', radio);
        //   if(radio.parentElement.classList.contains('active')){
        //     console.log('radio 2', radio.getAttribute('qty'));
        //   }
        // });
      }

      async onSubmitHandler(evt) {
      
        evt.preventDefault();
        if (evt.target.getAttribute('aria-disabled') === 'true') return;

        this.handleErrorMessage();

        evt.target.setAttribute('aria-disabled', true);
        evt.target.classList.add('loading');

        const config = {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: `application/javascript` },
        };
        config.headers['X-Requested-With'] = 'XMLHttpRequest';

        let product = this.form.querySelector('[name=id]').value;
        let sellingPlanId = this.form.querySelector('.selected-selling-plan-id').value;
        const subscription_promo_product = this.form.querySelector('[name=subscription_promo_product]');
        //let quantity = this.form.querySelector('[name=quantity]');
        //let quantity = document.querySelector('ul.delivery-options.active input[type="radio"][data-radio-type="selling_plan"]').getAttribute('qty').replace(/\s/g, '');
        let quantity = (document.querySelectorAll('li.delivery-item.active input[type="radio"][data-radio-type="selling_plan"]').length > 0 ? document.querySelector('li.delivery-item.active input[type="radio"][data-radio-type="selling_plan"]').getAttribute('qty').replace(/\s/g, '') : 1);
        let formData = {
          items: [{ id: product, quantity: Number(quantity), selling_plan: sellingPlanId }]
        };

        let productPlanOption = this.getPlanOptions[sellingPlanId]
        
        if (sellingPlanId) {
      
          if (subscription_promo_product && subscription_promo_product.value) {
          
            const hasFreeProduct = await this.hasFreeProduct(subscription_promo_product.value);
          
            if (!hasFreeProduct) {
              formData.items.push({
                id: subscription_promo_product.value,
                quantity: 1,
              });
            }
          }
        }

        if(document.querySelectorAll('label.input-one-time-purchase.active').length > 0) {
          let id = document.querySelector('input.data-variant:checked').getAttribute('variant-id'),
            quantity = document.querySelector('input.data-variant:checked').getAttribute('qty');

            formData = {
              items: [{ id: Number(id), quantity: Number(quantity) }]
            };
        } else {
          quantity = (document.querySelectorAll('li.delivery-item.active input[type="radio"][data-radio-type="selling_plan"]').length > 0 ? document.querySelector('li.delivery-item.active input[type="radio"][data-radio-type="selling_plan"]').getAttribute('qty').replace(/\s/g, '') : 1);
          formData = {
            items: [{ id: product, quantity: Number(quantity), selling_plan: sellingPlanId }]
          };
        }

        this.additionalProducts.forEach(additionalProduct => {
          let item = {
            id: additionalProduct.variantId,
            quantity: additionalProduct.quantity,
          };

          let extra_selling_plan = additionalProduct.sellingPlans[productPlanOption];

          if (productPlanOption && extra_selling_plan) {
            item.selling_plan = extra_selling_plan;
          }

          formData.items.push(item);
        }
        );

        fetch(`${routes.cart_add_url}`, {
          ...config,
          body: JSON.stringify(formData)
        })
          .then((response) => response.json())
          .then((response) => {
            if (response.status) {
              this.handleErrorMessage(response.description);

              const soldOutMessage = evt.target.querySelector('.sold-out-message');
              if (!soldOutMessage) return;
              evt.target.setAttribute('aria-disabled', true);
              soldOutMessage.classList.remove('hidden');
              this.error = true;
              return;
            }
            if (!this.error)
              this.error = false;
          })
          .catch((e) => {
            console.error(e);
          })
          .finally(() => {
            evt.target.classList.remove('loading');
            if (this.cart && this.cart.classList.contains('is-empty')) this.cart.classList.remove('is-empty');
            if (!this.error) evt.target.removeAttribute('aria-disabled');
            theme.Header.openCartDrawer();
            // window.SLIDECART_UPDATE(window.SLIDECART_OPEN());
            // //se coloca el set timeout para darle tiempo q renderize el draw cart
            // setTimeout(function(){
            //   if(subscription_promo_product && subscription_promo_product.value){
            //     console.log('slide open')
            //     let buttons = document.querySelectorAll(`.item[data-line-item-id="${subscription_promo_product.value}"] .quantity-selector button`);
            //     let inputs = document.querySelectorAll(`.item[data-line-item-id="${subscription_promo_product.value}"] .quantity-selector input`);
            //     console.log('buttons', buttons);
            //     console.log('inputs', inputs);
            //     if(buttons.length > 0) {
            //       buttons.forEach((button) => {
            //         button.style.display = 'none';
            //       });
            //     }

            //     if(inputs.length > 0) {
            //       inputs.forEach((input) => {
            //         input.setAttribute('disabled', 'disabled');
            //         input.setAttribute('style', 'pointer-events: none;');
            //         input.setAttribute('style', 'border: none !important;');
            //       });
            //     }
            //   }
            // }, 500);
          });
      }

      onClickOneTimeBanner(evt) {
        this.querySelector('.subscribe-and-save-box').click();
        this.querySelector('.subscribe-and-save-box').scrollIntoView({ block: "center" });
      }

      handleErrorMessage(errorMessage = false) {
        if (this.hideErrors) return;

        this.errorMessageWrapper =
          this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
        if (!this.errorMessageWrapper) return;
        this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

        this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

        if (errorMessage) {
          this.errorMessage.textContent = errorMessage;
        }
      }

      toggleSubmitButton(disable = true, text) {
        if (disable) {
          this.submitButton.setAttribute('disabled', 'disabled');
          if (text) this.submitButtonText.textContent = text;
        } else {
          this.submitButton.removeAttribute('disabled');
          this.submitButtonText.textContent = window.variantStrings.addToCart;
        }
      }

      get variantIdInput() {
        return this.form.querySelector('[name=id]');
      }

      get getPlanOptions() {
        const options = document.querySelectorAll('option[data-plan-option]');

        const planOptions = {};

        options.forEach(option => {
          const value = option.getAttribute('data-plan-option').toUpperCase();
          const key = option.value;
          planOptions[key] = value;
        });

        return planOptions;
      }

      clearAdditionalProducts() {
        const extras = this.querySelectorAll('extras-subscription');
        extras.forEach(extra => {
          extra.clearAddedProducts();
        });
        this.additionalProducts = [];
      }

      async hasFreeProduct(freeProductId) {
        const response = await fetch('/cart.js');
        const cart = await response.json();
        const productExists = cart.items.some(item => item.id == freeProductId);

        return productExists;
      }
    }
  );
}
